import React, { useState } from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import useLanguageChange from "../../../../hooks/useLanguageChange";
import { VIDEO_QUALITY_LIST } from "../../../../constants/CallSettingConstants";
import { changeVideoQuality } from "./CallSettingUtils";

const VideoQualityDropDown = () => {
    const localisedValues = useLanguageChange();
    const { currentSelectedVideoQuality } = useSelector((state) => state.callSetting);
    const { isRemoteParticipantJoined } = useSelector((state) => state.commonReducer);
    const [showSaveLabel, setShowSaveLabel] = useState(false);

    const handleChangeVideoQuality = (videoQuality) => {
        changeVideoQuality(videoQuality.value);
        setShowSaveLabel(true);
        setTimeout(() => {
            setShowSaveLabel(false);
        }, 3000);
    };

    return (
        <div className='form-group'>
            <label className='form-label'>{localisedValues["video_quality"]}</label>
            <div className='dropdown custom-dropdown dropdown-select call-settings-dropdown custom-tooltip tooltip-auto-width m-hide margin-0 right-tooltip'>
                <button
                    className='btn dropdown-toggle triangle-none'
                    type='button'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                    disabled={!isRemoteParticipantJoined}
                >
                    <span className='btn-text'>{localisedValues[currentSelectedVideoQuality.labelKey]}</span>
                    <span className='dropdown-toggle-arrow icon-down-arrow-light'></span>
                </button>
                <div className='dropdown-menu'>
                    <div className='dropdown-menu-in custom-scroll-thin'>
                        <ul>
                            {VIDEO_QUALITY_LIST.map((videoQuality) => {
                                const isSelectedVideoQuality = currentSelectedVideoQuality.value === videoQuality.value;
                                return (
                                    <li key={videoQuality.value}>
                                        <button
                                            className={clsx("btn dropdown-item", isSelectedVideoQuality && "active")}
                                            onClick={() => handleChangeVideoQuality(videoQuality)}
                                        >
                                            {localisedValues[videoQuality.labelKey]}
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
                {!isRemoteParticipantJoined && (
                    <div className='custom-tooltip-content text-nowrap'>
                        <div className='custom-tooltip-in'>
                            <p>{localisedValues["wait_for_the_call_to_start"]}</p>
                        </div>
                    </div>
                )}
            </div>
            {showSaveLabel && <div>{localisedValues["saved_label"]}</div>}
        </div>
    );
};

export default VideoQualityDropDown;
